<div class="container">
  <img [src]="getAlertImg()" alt="warning-icon" />
  @if (data.tittle) {
    <div class="tittle">
      {{ data.tittle }}
    </div>
  }
  @if (data.type === 'error' && !data.text) {
    <span>
      Ha ocurrido un error. <br />
      ¡Vuelve a intentarlo!
    </span>
  } @else {
    <span [innerHTML]="data.text"></span>
  }
  <div class="container-buttons">
    <button
      mat-flat-button
      class="btn-save"
      [mat-dialog-close]="true"
      [ngStyle]="{
        width: data.hiddeCancelBtn,
        order: data.invertOrder ? '1' : '2',
      }"
    >
      {{ data.saveButtonText ? data.saveButtonText : 'Cerrar' }}
    </button>
    @if (!data.hiddeCancelBtn) {
      <button
        mat-flat-button
        class="btn-cancel"
        [mat-dialog-close]="false"
        [ngStyle]="{
          width: data.hiddeCancelBtn,
          order: data.invertOrder ? '2' : '1',
        }"
      >
        {{ data.cancelButtonText ? data.cancelButtonText : 'Cancelar' }}
      </button>
    }
  </div>
</div>
